













































































import {Prop, Watch} from "vue-property-decorator";
import {Component, Vue} from '@/shared/component';
import {Stored} from 'vue-stored-prop-decorator';
import {Achat, DestType, EssenceAchat, Livraison, User} from "@/models";
import storeEssenceAchat from "@/stores/modules/essenceAchat";
import storeAchat from "@/stores/modules/achat";

import CrudLivraisonListLivraisonDialog from "@/components/Crud/Livraison/ListLivraisonDialog.vue";
import CrudLivraisonEditDialog from "@/components/Crud/Livraison/EditDialog.vue";
import CrudDeleteDialog from "@/components/Crud/DeleteDialog.vue";
import CrudEssenceAchatEditDialog from "@/components/Crud/EssenceAchat/EditDialog.vue";
import storeUser from "@/stores/modules/user";

@Component({
	components: {
		CrudDeleteDialog,
		CrudLivraisonListLivraisonDialog,
		CrudLivraisonEditDialog,
		CrudEssenceAchatEditDialog,
	}
})
export default class CrudEssenceAchatList extends Vue {

	private editLivraison: Livraison = null;
	private listLivraison: Livraison = null;
	private editEssenceAchat: EssenceAchat = null;
	private deletedEssenceAchat: EssenceAchat = null;
	private storeEssenceAchat = storeEssenceAchat;
	private storeAchat = storeAchat;

	@Prop({type: Boolean, default: true  }) public paginate!: boolean;
	@Prop({type: Boolean, default: false }) public dense!   : boolean;

	@Prop({type: [ Achat ], default: null }) public achat!: Achat;
	@Stored(() => storeUser) me!: User;

	private headers = [];

	public emitChange() {
		this.$emit('change')
	}

	public mounted(): void {
		this.headers.push({ text: 'Essence', value: 'essence' },)
		this.headers.push({ text: 'Volume', value: 'volume' },)
		this.headers.push({ text: 'Livraisons', value: 'action2' },)
		this.headers.push({ text: 'Fin de coupe ?', value: 'finCoupe' },)
	}

	public newLivraison(essence: EssenceAchat): void {
		this.editLivraison = new Livraison();
		this.editLivraison.essenceAchat = essence;
		this.editLivraison.date = new Date();
		this.editLivraison.destType = DestType.Depot;
	}

	private onDeleteEssence(): void {
		this.achat.essenceAchats.splice(this.achat.essenceAchats.findIndex(v => v.id == this.deletedEssenceAchat.id), 1);
	}

	private async onEditEssence(): Promise<void> {
		await storeAchat.dispatch('get', this.achat.id);
	}

	private async onCreateLivraison(): Promise<void> {
		await storeAchat.dispatch('get', this.achat.id);
		this.emitChange();
	}

	private async finCoupe(essenceAchat: EssenceAchat): Promise<void> {
		await storeEssenceAchat.dispatch('putFinCoupe', essenceAchat);
		this.emitChange();
	}

}
